module.exports = __webpack_public_path__ + "static/img/SRG_Succession_Planning_Case_Study.0736420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SRG_Succession_Planning_Case_Study.png
// module id = 2wCj
// module chunks = 0